


// export const handleBeforeInput = (regx, max) => (e) => {
  //   const inputValue = e.target.value + e.data;
//   console.log(inputValue);

//   if (inputValue.length > max || !regx.test(e.data)) {
//     e.preventDefault();
//   }
// };

export const handleBeforeInput = (regx, max) => (e) => {
  const { value, selectionStart, selectionEnd } = e.target;
  const nextValue = value.slice(0, selectionStart) + e.data + value.slice(selectionEnd);

  if (nextValue.length > max || !regx.test(e.data)) {
    e.preventDefault();
  }
};
